<template>
  <div class="product-series-page">
    <div class="search">
      <div class="left">
        <el-form
          :inline="true"
          class="query-form"
          @submit.native.prevent
        >
          <el-row
            :gutter="20"
            class="query-row"
          >
            <el-col
              :span="queryKeywordSpan"
              class="query-item"
            >
              <el-form-item>
                <el-input
                  v-model.trim="search.keyword"
                  placeholder="请输入产品系/聚合预算/产品名称"
                  clearable
                  style="width: 100%"
                  @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="queryActionSpan"
              class="query-item query-item--actions"
            >
              <div class="query-buttons">
                <el-button
                  plain
                  type="primary"
                  @click="handleReset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="handleSearch"
                >
                  查询
                </el-button>
                <!-- <el-button
                  v-if="showQueryToggle"
                  type="text"
                  class="query-toggle"
                  @click="toggleQueryExpand"
                >
                  {{ queryExpanded ? '收起' : '展开' }}
                  <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                </el-button> -->
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="data">
      <div class="table-header-actions">
        <el-button
          type="primary"
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'budgets'">
              <el-tag
                v-for="v in (scope.row.budgets)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'products'">
              <el-tag
                v-for="v in (scope.row.products)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'opt'">
              <el-button
                type="text"
                @click="handleEditDialogOpen(scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                @click="handleEditProduct(scope.row)"
              >
                修改产品
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlLogOpen(scope.row)"
              >
                日志
              </el-button>
            </template>
            <template v-else>
              {{ scope.row[c.prop] }}
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 -->
    <el-dialog
      :visible.sync="detailVisible"
      :title="`${isEdit ? '修改' : '添加'}产品系`"
      width="600px"
      class="dialog"
    >
      <el-form label-width="120px">
        <el-form-item label="产品系">
          <el-input
            v-model="form.name"
            placeholder="请输入产品系名称"
            class="input"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改产品 -->
    <form-dialog
      :visible.sync="productVisible"
      title="修改产品"
      width="600px"
      @submit="handleProductDialogConfirm"
    >
      <el-form label-width="100px">
        <el-form-item label="已选择产品">
          <div v-if="productForm.products.length">
            <el-tag
              v-for="(v, index) in productForm.products"
              :key="v.id"
              size="small"
              closable=""
              style="margin-left: 8px;"
              @close="handleCloseProduct(v, index)"
            >
              {{ v.name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>
        <el-form-item label="选择产品">
          <el-select
            v-model="productForm.selectProducts"
            multiple
            filterable
            remote
            :remote-method="_searchProduct"
            :loading="editProdProductDlg.searchLoading"
            placeholder="请选择合作产品"
            style="width: 100%"
            @change="onProductChange"
          >
            <el-option
              v-for="item in editProdProductDlg.prodOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
      width="800px"
      @close="handleCloseLog"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { cloneDeep } from 'lodash';
import FormDialog from '@/components/FormDialog';

const req = new Request();
const createDefaultSearch = () => ({
  keyword: '',
});

export default {
  name: 'product-series-all',
  components: {
    FormDialog,
  },
  data() {
    return {
      queryExpanded: true,
      search: createDefaultSearch(),
      column: [
        { label: '产品系编号', prop: 'id' },
        { label: '产品系', prop: 'name' },
        { label: '产品名称', prop: 'products' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      detailVisible: false,
      productVisible: false,
      form: {
        id: '',
        name: '',
      },
      productForm: {
        id: '',
        products: [],
        selectProducts: [],
      },
      editProdProductDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        prodOps: [],
      },
      isEdit: false,
      logVisible: false,
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,
      userInfo: {},
    };
  },
  computed: {
    showQueryToggle() {
      return true;
    },
    queryKeywordSpan() {
      return 12;
    },
    queryActionSpan() {
      return 12
    },
  },
  mounted() {
    this.getUserInfo();
    this.getList();
  },

  methods: {
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    handleCloseLog() {
      this.logPage = 1;
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },
    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 4, // 产品系全部
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    async _searchProduct(key) {
      if (!key) return [];
      try {
        this.editProdProductDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.productSeries.productSeriesAll, { keyword: key })
          .fin(() => {
            this.editProdProductDlg.searchLoading = false;
          });
        const prods = (res.data || []).map((i) => ({
          product_id: i.id,
          product_name: i.name,
        }));
        this.editProdProductDlg.prodOps = [
          ...new Set([...prods].map((i) => JSON.stringify(i))),
        ].map((i) => JSON.parse(i));
      } catch (err) {
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },
    handleCloseProduct(products, index) {
      this.productForm.products.splice(index, 1);
    },
    onProductChange(value) {
      this.productForm.selectProducts = value;
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.search = createDefaultSearch();
      this.page = 1;
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.productSeries.listAll, {
          keyword: this.search.keyword,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },
    handleEditProduct(row) {
      this.productForm = {
        id: parseInt(row.id, 10),
        products: cloneDeep(row.products),
      };
      this.productVisible = true;
    },
    // dialog: open
    handleDialogOpen() {
      this.isEdit = false;
      this.detailVisible = true;
      this.form = {
        isEdit: false,
        id: '',
        name: '',
      };
    },
    // dialog: open
    handleEditDialogOpen(row) {
      this.isEdit = true;
      this.detailVisible = true;
      this.form = {
        isEdit: true,
        id: parseInt(row.id, 10),
        name: row.name,
      };
    },
    async handleDialogConfirm() {
      let params = {
        name: this.form.name,
      };
      let api = req.Apis.customer.productSeries.addAll;

      if (!this.form.name) {
        this.$message.error('请输入产品系名称');
        return;
      }

      if (this.form.id) {
        params.id = this.form.id;
        api = req.Apis.customer.productSeries.updateAll;
      }

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
        this.detailVisible = false;
      } catch (err) {}
    },
    async handleProductDialogConfirm() {
      const _ids = (this.productForm.products || []).map((item) => item.product_id);
      let params = {
        id: this.productForm.id,
        product_ids: [...(_ids || []), ...(this.productForm.selectProducts || [])],
      };
      let api = req.Apis.customer.productSeries.updateProductAll;

      try {
        const res = await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {
        console.log('error', error)
      }
      this.productVisible = false;
    },
  },
};
</script>

<style lang="less">
.product-series-page {
  .table-header-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }

  .search {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .left {
    flex: 1;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .data {
    margin-top: 20px;

    .page {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog {
    .input {
      width: 400px;
    }
  }
}

.product-series-page .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.product-series-page .query-form .el-form-item__content {
  width: 100%;
}

.product-series-page .query-buttons .el-button + .el-button {
  margin-left: 0;
}
</style>
